import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=8e3b1a74&scoped=true&"
import script from "./ComingSoon.vue?vue&type=script&lang=js&"
export * from "./ComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=8e3b1a74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3b1a74",
  null
  
)

export default component.exports